import { gql } from "@apollo/client";

export const GET_ITEM_CATEGORIES = gql`
  query item_categories($where: dashboard_reference_bool_exp!) {
    dashboard_reference(order_by: { reference_label: asc }, where: $where) {
      reference_value
      reference_label
    }
  }
`;


export const GET_TICKETING_ITEMS = gql`
  query items($where: items_ticketing_bool_exp) {
    items_ticketing(where: $where, order_by: { name: asc }) {
    is_active
    event_id
    id
    tab_id
    sort_order
    modifiers
    tab {
      id
      name
      sort_order
    }
    last_updated_by
    order_quantity_limit
    price
    sales_limit
    sales_limit_balance
    token_payload
    tax_percentage
    category
    description
    additional_email_description
    name
    event {
      name
      id
    }
    user {
      id
      username
    }
    created_at
    off_sale_date
    on_sale_date
    updated_at
    unlimited_ingress
    include_egress
    include_pos_tokens
    pos_token_payload
    available_public_sale
    cashless_top_up_item
    included_cash_balance
    included_promo_balance
  }
}
`;

export const GET_TICKETING_ITEM = gql`
  query GetTicketingItem($id: Int!) {
    items_ticketing_by_pk(id: $id) {
    is_active
    event_id
    id
    tab_id
    sort_order
    modifiers
    tab {
      id
      name
      sort_order
    }
    last_updated_by
    order_quantity_limit
    price
    sales_limit
    sales_limit_balance
    tax_percentage
    category
    description
    additional_email_description
    name
    created_at
    off_sale_date
    on_sale_date
    updated_at
    include_egress
    include_pos_tokens
    pos_token_payload
    token_payload
    unlimited_ingress
    available_public_sale
    cashless_top_up_item
    included_cash_balance
    included_promo_balance
    event {
      id
      name
    }
    user {
      username
    }
    }
  }
`;

export const GET_TICKETING_TABS = gql`
  query ticketing_tabs($where: items_ticketing_tabs_bool_exp) {
    items_ticketing_tabs(
      where: $where
      order_by: [{ event_id: asc }, { sort_order: asc }, { name: asc }]
    ) {
      id
      event_id
      name
      sort_order
      is_active
      items {
        id
      }
    }
  }
`;
